import { CONVERSION_RATE_ALIAS, LIQUIDATION_PREFERENCE_ALIAS, SENIORITY_ALIAS } from 'common/constants/cap-table';
import { CapTableCell } from '../components/captable-table/CaptableTable.props';

const getUnderlyingSecurityCells = ({ cells, underlyingSecurityRef }: { cells: Record<string, CapTableCell>, underlyingSecurityRef: string }) => {
  const matchingCells = Object.values(cells).filter(
    ({ alias, securityRef }) =>
      [CONVERSION_RATE_ALIAS, SENIORITY_ALIAS, LIQUIDATION_PREFERENCE_ALIAS].includes(alias)
      && securityRef === underlyingSecurityRef
  );

  return matchingCells.length > 0 ? matchingCells : null;
};

export default getUnderlyingSecurityCells;
